var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil0 {fill:none}\r\n    .fil4 {fill:#D32F2F}\r\n    .fil1 {fill:#EF9A9A}\r\n    .fil2 {fill:#FFCDD2}\r\n    .fil3 {fill:#D32F2F;fill-rule:nonzero}\r\n    .fil5 {fill:white;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2048,
    height: 2048
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 255.999,
    y: 255.999,
    width: 1536,
    height: 1536
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1303.19 263.999l328.759 329.158 -269.982 0c-32.328,0 -58.7764,-26.4484 -58.7764,-58.7764l0 -270.382z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M454.851 263.999l848.395 0 0 268.747c0,33.228 27.1843,60.4111 60.4111,60.4111l268.344 0 0 814.843c0,22.0004 -17.9988,39.9992 -39.9992,39.9992l-1137.15 0c-22.0004,0 -39.9992,-17.9988 -39.9992,-39.9992l0 -1104c0,-22.0004 17.9988,-39.9992 39.9992,-39.9992z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "671.999,763.342 1408,763.342 1408,827.344 671.999,827.344 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "671.999,987.337 1408,987.337 1408,1051.34 671.999,1051.34 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M337.396 1226.19l1373.21 0c22.3748,0 42.7347,9.23387 57.5103,24.1075 14.7378,14.8358 23.8866,35.2382 23.8866,57.6189l0 394.353c0,22.3807 -9.15001,42.7819 -23.8866,57.6178 -14.7768,14.8736 -35.1366,24.1087 -57.5103,24.1087l-1373.21 0c-22.3725,0 -42.7347,-9.23505 -57.5115,-24.1087 -14.7366,-14.8335 -23.8855,-35.2347 -23.8855,-57.6178l0 -394.353c0,-22.3819 9.14883,-42.7831 23.8855,-57.6189 14.7744,-14.8736 35.1366,-24.1075 57.5115,-24.1075z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M572 1684.05l0 -357.917 115.916 0c43.917,0 72.5835,1.83307 85.917,5.41654 20.5004,5.33386 37.7504,17.0008 51.5835,35.0008 13.8331,18 20.7496,41.25 20.7496,69.6662 0,22.0004 -3.99922,40.5 -12,55.4162 -7.99961,15 -18.0827,26.7508 -30.4158,35.3339 -12.2504,8.5004 -24.75,14.1662 -37.4174,16.9169 -17.25,3.41575 -42.2492,5.16615 -75.0001,5.16615l-47.0835 0 0 135 -72.2493 0zm72.2493 -297.333l0 101.5 39.5008 0c28.5,0 47.5831,-1.83425 57.1666,-5.58426 9.58347,-3.75 17.0835,-9.58347 22.5827,-17.5831 5.41654,-7.99961 8.16733,-17.25 8.16733,-27.8327 0,-13.0004 -3.83386,-23.7508 -11.5004,-32.25 -7.58268,-8.41654 -17.3327,-13.7504 -28.9996,-15.8339 -8.66694,-1.66654 -26.0008,-2.41654 -52.0004,-2.41654l-34.917 0zm261 -60.5835l132.084 0c29.7496,0 52.4162,2.25 68.0823,6.83386 21,6.16654 39,17.1662 53.9174,33 15,15.75 26.4166,35.0835 34.2496,57.9166 7.7504,22.9158 11.6669,51.0827 11.6669,84.6662 0,29.4166 -3.66733,54.8339 -10.9996,76.167 -8.91733,25.9996 -21.6673,47.0835 -38.3339,63.1666 -12.4996,12.2504 -29.4166,21.75 -50.7496,28.5827 -15.9165,5.08347 -37.2508,7.58386 -64.0004,7.58386l-135.917 0 0 -357.917zm72.2504 60.5835l0 237 53.9162 0c20.1673,0 34.7504,-1.08307 43.7504,-3.41693 11.6669,-2.91614 21.4169,-7.83308 29.1662,-14.8335 7.7504,-6.99922 14.0008,-18.5835 18.9165,-34.5827 4.83307,-16.0004 7.33347,-37.917 7.33347,-65.5843 0,-27.6662 -2.5004,-48.8327 -7.33347,-63.6662 -4.91575,-14.8335 -11.7496,-26.4166 -20.4992,-34.6666 -8.83347,-8.33386 -20.0008,-13.9169 -33.5008,-16.8331 -10.0831,-2.33386 -29.8335,-3.41693 -59.3327,-3.41693l-32.4166 0zm289.5 297.333l0 -357.917 245.416 0 0 60.5835 -173.082 0 0 84.6662 149.417 0 0 60.5835 -149.417 0 0 152.084 -72.3331 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.1e9086d1cc8a81d4fc8371f27bf3740b.svg";
export { ForwardRef as ReactComponent };